const HeroSection = () => {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen w-full flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/dbe620240c8c259222da3444792dcf95.jpg"
          alt="HELIX Smart Ring"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-16">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 mb-8 animate-fade-in">
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse-ring" />
            <span className="font-body text-xs text-white/90 tracking-widest uppercase font-medium">
              Disponible ahora · Envío inmediato
            </span>
          </div>

          {/* Heading */}
          <h1 className="font-display text-white leading-tight mb-6 animate-fade-up">
            <span className="block text-5xl lg:text-7xl font-light tracking-tight">
              Tu salud,
            </span>
            <span className="block text-5xl lg:text-7xl font-semibold tracking-tight text-gradient">
              en un anillo.
            </span>
          </h1>

          {/* Subheading */}
          <p className="font-body text-white/70 text-lg lg:text-xl font-light leading-relaxed mb-10 max-w-xl animate-fade-up" style={{ animationDelay: '0.15s' }}>
            HELIX mide tu ritmo cardíaco, sueño y actividad con precisión médica.
            Sin pantalla. Sin cargar. Solo datos que importan, en el dedo más discreto.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-up" style={{ animationDelay: '0.3s' }}>
            <button
              onClick={() => handleScroll('#precio')}
              className="whitespace-nowrap bg-amber-600 hover:bg-amber-700 text-white font-body font-medium text-base tracking-wide px-8 py-4 rounded-full cursor-pointer transition-all duration-200 flex items-center justify-center gap-2 group"
            >
              Comprar ahora
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </button>
            <button
              onClick={() => handleScroll('#beneficios')}
              className="whitespace-nowrap bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-body font-medium text-base tracking-wide px-8 py-4 rounded-full cursor-pointer transition-all duration-200"
            >
              Descubrir más
            </button>
          </div>

          {/* Stats row */}
          <div className="flex flex-wrap items-center gap-8 mt-14 animate-fade-up" style={{ animationDelay: '0.45s' }}>
            {[
              { value: '24/7', label: 'Monitoreo continuo' },
              { value: '7 días', label: 'Batería' },
              { value: '< 3mm', label: 'Grosor del anillo' },
            ].map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <span className="font-display text-2xl font-semibold text-white">{stat.value}</span>
                <span className="font-body text-xs text-white/50 tracking-wide uppercase">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-float opacity-60">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center pt-2">
          <div className="w-1 h-2 bg-white/60 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
